import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import StyledStack from 'views/rebranded-module/common/components/UI/SectionTitle/SectionTitle.styles';
import { Typography700 } from 'views/rebranded-module/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';

const SectionTitle = (props) => {
  const { title, text, action } = props;

  return (
    <StyledStack>
      <Box>
        <Typography700 variant="h4" component="h4" className="word-break">
          {title}
        </Typography700>

        {text && (
          <Typography
            variant="body1"
            color="textSecondary"
            mt={3}
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          />
        )}
      </Box>

      {action && (
        <Button
          component={action.path ? NavigatorLink : 'button'}
          href={action.path}
          onClick={action.onClick}
          variant="contained"
          color="primary"
          size="large"
          className="STAction">
          {action.text}
        </Button>
      )}
    </StyledStack>
  );
};

export { SectionTitle };
